import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { SmallTextButton } from '../../components/button/text/SmallTextButton';
import { useCommentariesModal } from '../../commentary/components/commentaries-modal/useCommentariesModal';

type Props = {
  count: number;
  docId: string;
};

export const CommentaryCountChip: FC<Props> = ({ count, docId }) => {
  const openModal = useCommentariesModal({
    source: 'decision_popover',
    docId,
    trackingOnClick: 'Decision ModalCommentClicked',
    trackingOnOpen: 'Decision ModalCommentsOpened',
  });

  return (
    <SmallTextButton onClick={openModal}>
      <FormattedMessage id="CommentaryCountChip" values={{ count }} />
    </SmallTextButton>
  );
};
